const extractSingleValueFromArrayOfObject = (propertyName: string, array: Array<any> | string) => {
	if(typeof array === "string"){
		return array.split(",");
	}

	if(!array || array.length === 0 || !propertyName)
		return undefined;

	const propertyNameExistsInObject = propertyName in array[0];

	if(!propertyNameExistsInObject)
		return undefined;

	const newArray = array.map((arr) => arr[propertyName]);

	return newArray;
};

export default extractSingleValueFromArrayOfObject;
